import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Header from './Header'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { CustomInput, CustomDatePicker } from './Component'
import useStore from './store'
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";
import { doPost } from './AjaxRequests'
import Swal from 'sweetalert2'
import _ from 'lodash'
import { format } from 'date-fns'
import UploadTestKitImage from './UploadTestKitImage'




const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.paper.white,
    },
    subTitle: {
        color: theme.palette.text.white,
        fontSize: "18px"
    },
    btn__wrapper: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        padding: theme.spacing(1, 0),
        
    },
    button: {
        width: "100%",
        fontSize:"20px"
    }
}));

export default function Login(props) {

    const classes = useStyles()
    const store = useStore()
    const [submiting, setSubmiting] = useState(false)
    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const [camPermission, setCamPermission] = useState(true)


    const [open, setOpen] = useState(false);

    const onOpenModal = () => setOpen(true);
    const onCloseModal = () => setOpen(false);

    // const [cookies, setCookie] = useCookies(['data_encode']);

    useEffect(() => {

        let info = {
            name: "",
            idno: "",
            phone: "",
            birthday: ""
        }

        if (window.localStorage) {
            let localStorage = window.localStorage
            const idAndPhone = localStorage.idAndPhone
            if (idAndPhone) {
                setLoading(true)
                doPost(`https://www.kfsyscc.org/normal_api/service`, {
                    "api": "aesdecode",
                    "str": idAndPhone
                })
                    .then((data) => {
                        if (data.data.status === 200) {
                            let result = JSON.parse(data.data.data.result)

                            if (result.name) {
                                info.name = result.name
                            }

                            if (result.idno) {
                                info.idno = result.idno
                            }
                            if (result.phone) {
                                info.phone = result.phone
                            }
                            if (result.birthday) {
                                info.birthday = result.birthday
                            }
                        }
                        store.setLogin({ ...store.login, ...info })
                        setLoading(false)
                    })
                    .catch(() => {
                        store.setLogin({ ...store.login, ...info })
                        setLoading(false)
                    })
            }


        } else {
            store.setLogin({ ...store.login, ...info })
        }

    }, [])

    const setLogin = (field, value) => {
        let payload = {}
        if (field.includes("idno")) {
            payload[field] = value.toUpperCase()
        } else {
            payload[field] = value
        }

        store.setLogin({ ...store.login, ...payload })
    }

    const handleTodayDoc = async () => {

        const valid = await handleSubmit()

        if (!store.login.patientIdno) {
            Swal.fire('請輸入病人身份證號(申請陪病證者必填)', "", "error")
            return
        }

        if (!valid) {
            return
        }

        const payload = {
            "api": "ApplyDoorAccessKey",
            "reg_date": format(new Date(), "yyyyMMdd"),
            "apply_user_idno": store.login.idno,
            "apply_user_name": store.login.name,
            "apply_user_birthday": store.login.birthday,
            "apply_user_mail": "",
            "apply_user_phone": store.login.phone,
            "idno": store.login.patientIdno,
            "reason": "REGE",
            "remark": "",
            "auth_code": "",
            // "dept":store.gerneralInfo.dept,                                     
            "cre_user_id": props.user === null ? "PATIENT" : props.user.USER_ID,
            "form_id": "V09-09-10",
            "form_ver": "3",
            "tocc": {}
        }

        const data = await doPost('https://www.kfsyscc.org/normal_api/service', payload)

        if (data.data.pass === "Y") {
            history.push(`/result?access_key=${data.data.access_key}&result_type=query`)
        } else if (data.data.pass === "N") {
            Swal.fire(data.data.message, "", "warning")
        } else {
            throw Error("連線錯誤")
        }
        // if (data.status && data.data.length > 0){
        //     const dateStr = format(new Date(), "yyyyMMdd")
        //     const docs = _.filter(data.data, (item)=>item.reg_date === dateStr)
        //     if(docs.length>0){
        //         history.push(`/result?access_key=${docs[0].access_key}&result_type=query`)
        //     }else{
        //         Swal.fire("查無當日申請紀錄", "", "info")
        //     }
        // }else{
        //     Swal.fire("查無申請紀錄", "", "info")
        // }
    }

    const handleApplyHistory = async () => {
        const valid = await handleSubmit()

        if (!valid) {
            return
        }
        history.push('/applyHistory')

    }

    const handleApply = () => {
        history.push('/page1')
    }

    const handleSubmit = async () => {

        if (!store.login.name) {
            Swal.fire("請輸入申請人姓名", "", "error")
            return
        }

        if (!store.login.idno) {
            Swal.fire("請輸入申請人身分證字號", "", "error")
            return
        }

        if (!store.login.phone) {
            Swal.fire("請輸入申請人手機", "", "error")
            return
        }

        if (!store.login.birthday) {
            Swal.fire("請輸入申請人生日", "", "error")
            return
        }




        setSubmiting(true)
        let payload = {
            name: store.login.name,
            idno: store.login.idno,
            phone: store.login.phone,
            birthday: store.login.birthday
        }

        try {
            const data = await doPost(`https://www.kfsyscc.org/normal_api/service`,
                {
                    "api": "aesencode",
                    "str": JSON.stringify(payload)
                }
            )

            if (window.localStorage) {
                window.localStorage.idAndPhone = data.data.data.result
            }

            setSubmiting(false)
            return true

        } catch {
            setSubmiting(false)
            return
        }




        // .then((data)=>{    
        //     if(window.localStorage){
        //         window.localStorage.idAndPhone = data.data.data.result
        //     }        
        //     // setCookie('data_encode',data.data.data.result, {maxAge:60*60*24*7})
        //     setSubmiting(false)
        //     return true
        //     // history.push('/applyHistory')            
        // })
        // .catch(()=>{
        //     setSubmiting(false)
        //     return false
        //     // history.push('/applyHistory') 
        // })

    }



    if (loading) {
        return <div>loading...</div>
    }

    return <Grid container spacing={3}>
        <Grid item xs={12}>
            <Header />
        </Grid>
        <Grid item xs={12}>
            <Typography
                variant="h6"
                className={classes.subTitle}
            >
                請輸入以下資料
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <Paper
                square
                className={classes.paper}
                elevation={3}
            >
                <Grid container spacing={2}>
                    <CustomInput
                        width={12}
                        field="name"
                        value={store.login.name}
                        handleSelectChange={setLogin}
                        placeHolder="申請人姓名"
                    />
                    <CustomInput
                        width={12}
                        field="idno"
                        value={store.login.idno}
                        handleSelectChange={setLogin}
                        placeHolder="申請人身分證字號"
                    />
                    <CustomInput
                        width={12}
                        field="phone"
                        value={store.login.phone}
                        handleSelectChange={setLogin}
                        placeHolder="申請人手機"
                    />

                    <CustomDatePicker
                        width={12}
                        value={store.login.birthday}
                        handleSelectChange={setLogin}
                        label="申請人生日"
                        field="birthday"
                        openTo="year"
                    />



                    <CustomInput
                        width={12}
                        field="patientIdno"
                        value={store.login.patientIdno}
                        handleSelectChange={setLogin}
                        placeHolder={"病人身份證號(申請陪病證者必填)"}
                    // error = {error.gerneralInfo.idno}                                       
                    />
                    <FormControlLabel
                        control={
                            <Checkbox onChange={(e) => {
                                if (e.target.checked) {
                                    setLogin("patientIdno", "" + store.login.idno)
                                }
                            }} />
                        }
                        label={'與申請者身份證字號相同'}
                    />
                </Grid>
            </Paper>
        </Grid>
        <Grid item xs={12}>
            <div className={classes.btn__wrapper}>
                <Button variant="contained" className={classes.button} size='large' color="primary" onClick={handleTodayDoc}>
                ACC陪同治療病證申請
                </Button>
            </div>
        </Grid>
        <Grid item xs={12}>
            <div className={classes.btn__wrapper}>
                <Button variant="contained" className={classes.button} size='large' onClick={handleApply}>
                住院探/陪病及急診陪病證申請
                </Button>
            </div>
        </Grid>
        <Grid item xs={12}>
            <div className={classes.btn__wrapper}>
                <Button variant="contained" className={classes.button} size='large' color="secondary" onClick={handleApplyHistory}>
                我的通行證(含當日申請)
                </Button>
            </div>
        </Grid>
        <Grid item xs={12}>
            <div className={classes.btn__wrapper}>
                <Button variant="contained" className={classes.button} size='large' style={{ backgroundColor: "yellow" }} onClick={
                    ()=>{
                        if (!store.login.name) {
                            Swal.fire("請輸入申請人姓名", "", "error")
                            return
                        }
                
                        if (!store.login.idno) {
                            Swal.fire("請輸入申請人身分證字號", "", "error")
                            return
                        }


                        onOpenModal()
                        
                    }
                    }>
                    家用快篩陰性照片上傳
                </Button>
            </div>
        </Grid>


        <Grid item xs={12} variant="body2" style={{ color: "#FFF" }}>
            <Typography>
                *請使用Chrome(版本51以上),Safari(版本10以上)或Firefox(版本54以上)瀏覽器瀏覽此網頁
            </Typography>
        </Grid>
        {open && <UploadTestKitImage
            open={open}
            onCloseModal={onCloseModal}
            login={store.login}
            classes={classes}
            setLogin={setLogin}
            camPermission={camPermission}
            setCamPermission={setCamPermission}
        />}
        
    </Grid>
}





